module.exports = __webpack_public_path__ + "img/pg3-article-bg.9f0609fb.png";